import axois, { AxiosResponse } from "axios";
import { EventItem } from "src/modules/chat/models";
import { BaseApiService } from "../api-base";
import API_EXT from "../api-extensions";
import {
  GetEventsRequest,
  IdentifyAppResponse,
  RunDsRequest,
  RunDsResponse,
  SetEventRateRequest,
  SetMessageRateRequest,
} from "./dto";

export class CfApiService extends BaseApiService {
  constructor(host: string) {
    super("cf");
    this.http = axois.create({
      baseURL: host,
    });
    this.http.interceptors.request.use((config) => {
      config.headers.Authorization = this.jwt;
      return config;
    });
  }

  // DEPRICATED: use set_rate
  set_message_rate(data: SetMessageRateRequest) {
    const method = `${this.url}/bl/set_message_rate`;
    const body = {
      app_ref: this.app_ref,
      ...data,
    };
    return this.http.post(method, body).then((response) => response.data);
  }

  set_rate(data: SetEventRateRequest) {
    const method = `${this.url}/bl/set_rate`;
    const body = {
      app_ref: this.app_ref,
      ...data,
    };
    return this.http.post(method, body).then((response) => response.data);
  }

  run_ds(data: RunDsRequest): Promise<RunDsResponse> {
    const method = `${this.url}/bl/run_ds`;
    const body = {
      app_ref: this.app_ref,
      ...data,
    };
    return this.http.post(method, body).then((response) => response.data);
  }

  run_ds_safe(data: RunDsRequest): Promise<RunDsResponse> {
    const method = `${this.url}/bl/run_ds_safe`;
    const body = {
      app_ref: this.app_ref,
      ...data,
    };
    return API_EXT.postParallel(this.http, method, body).then(
      (response: AxiosResponse<RunDsResponse>) => {
        // костыль, для того, чтобы в след. запросе отправить backend,
        // чтобы в БД положить инфу о том, какой из backend'ов ответил
        response.data.api_state = {
          ...response.data.api_state,
          backend: response.config.baseURL,
        };
        return response.data;
      }
    );
  }

  make_reaction(session_guid: string, reaction_ref: string) {
    const method = `${this.url}/bl/make_reaction`;
    const body = {
      session_guid,
      reaction_ref,
      app_ref: this.app_ref,
      source: this.settings.clientSource,
    };
    return this.http.post(method, body).then((response) => response.data);
  }

  get_events(data: GetEventsRequest) {
    const method = `${this.url}/bl/get_events`;
    const body = {
      app_ref: this.app_ref,
      ...data,
    };
    return this.http
      .post<EventItem[]>(method, body)
      .then((response) => response.data);
  }

  get_event(guid: string) {
    const method = `${this.url}/bl/get_event`;
    const body = {
      app_ref: this.app_ref,
      guid,
    };
    return this.http
      .post<EventItem>(method, body)
      .then((response) => response.data);
  }

  clear_session_state(session_guid: string) {
    const method = `${this.url}/bl/clear_session_state`;
    const body = {
      app_ref: this.app_ref,
      session_guid: session_guid,
      source: this.settings.clientSource,
    };
    return this.http
      .post<RunDsResponse>(method, body)
      .then((response) => response.data);
  }

  identify_app(question: string) {
    const method = `${this.url}/bl/identify_app`;
    const body = {
      app_ref: this.app_ref,
      question: question,
    };
    return this.http
      .post<IdentifyAppResponse>(method, body)
      .then((response) => response.data);
  }

  fb_page_attach(fb_app_ref: string, exchange_token: string) {
    const method = `${this.url}/bl/fb_page_attach`;
    const body = {
      app_ref: this.app_ref,
      fb_app_ref: fb_app_ref,
      exchange_token: exchange_token,
    };
    return this.http
      .post<IdentifyAppResponse>(method, body)
      .then((response) => response.data);
  }
}
